import { ArrayFieldTemplateItemType, ArrayFieldTemplateProps } from '@rjsf/utils'
import Flex from 'antd/lib/flex'
import Button from 'antd/lib/button'
import DeleteFilled from '@ant-design/icons/lib/icons/DeleteFilled'
import PlusOutlined from '@ant-design/icons/lib/icons/PlusOutlined'
import StopOutlined from '@ant-design/icons/lib/icons/StopOutlined'

type EmptyContentProps = {
    items: ArrayFieldTemplateItemType[]
    onAddClick: () => void
    disabled?: boolean
    readonly?: boolean
}

const EmptyContent = (props: EmptyContentProps) => {
    const { items, onAddClick, disabled, readonly } = props

    if (items.length > 0) {
        return null
    }

    return (
        <Flex gap={10} align="center" justify="space-between" className="array-empty-content">
            <Flex gap={10} align="center" justify="center" className="array-empty-content-icon">
                <StopOutlined />
                <p className="array-empty-content-text">No items found</p>
            </Flex>
            <Button className="array-item-add" onClick={onAddClick} disabled={disabled || readonly}>
                <PlusOutlined /> Add Item
            </Button>
        </Flex>
    )
}

export const ArrayFieldTemplate: React.ComponentType<ArrayFieldTemplateProps> = props => {
    const { items, canAdd, onAddClick, disabled, readonly, className } = props

    return (
        <div className={className}>
            <EmptyContent
                items={items}
                onAddClick={onAddClick}
                disabled={disabled}
                readonly={readonly}
            />

            {items.map(item => (
                <Flex
                    key={item.key}
                    className="array-item"
                    wrap="wrap"
                    justify="flex-start"
                    gap={10}
                >
                    <div className="array-item-content">{item.children}</div>

                    {!item.readonly && !readonly && !disabled && (
                        <Flex gap={10} className="array-item-buttons">
                            <Button
                                icon={<DeleteFilled className="array-item-delete-icon" />}
                                onClick={item.onDropIndexClick(item.index)}
                            />
                        </Flex>
                    )}
                </Flex>
            ))}

            {canAdd && items.length > 0 && (
                <Button
                    className="array-item-add"
                    onClick={onAddClick}
                    disabled={disabled || readonly}
                >
                    <PlusOutlined /> Add Item
                </Button>
            )}
        </div>
    )
}
